export default __webpack_public_path__ + "locales/cs/InviteDialog.json?hash=7fdde237a3c81a4750d93ee71a33631b";